export enum ValidationStatus {
  VALID = <any>'VALID', // control has passed all validation checks
  INVALID = <any>'INVALID', // control has failed at least one validation check
  PENDING = <any>'PENDING', // control is in the midst of conducting a validation check
  DISABLED = <any>'DISABLED' // control is exempt from validation checks
}
